<div class="cards-container-content">
  <ng-content></ng-content>
</div>
